import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Loader2 } from "lucide-react";
const TableLoader = () => {
  return (
    <section className="pb-36 mx-auto max-w-6xl">
      <div className="bg-white rounded-lg shadow-lg overflow-hidden">
        <div className="px-6 py-4 bg-gradient-to-r from-[#33B9BA] to-[#00A3A8]">
          <h1 className="text-2xl font-bold text-white">Registrations</h1>
        </div>
        <div className="p-6">
          <div className="overflow-x-auto">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead className="bg-[#33B9BA] text-white font-semibold">
                    Title
                  </TableHead>
                  <TableHead className="bg-[#33B9BA] text-white font-semibold">
                    Date
                  </TableHead>
                  <TableHead className="bg-[#33B9BA] text-white font-semibold">
                    Total Amount
                  </TableHead>
                  <TableHead className="bg-[#33B9BA] text-white font-semibold">
                    Payment Status
                  </TableHead>
                  <TableHead className="bg-[#33B9BA] text-white font-semibold">
                    Event Participants
                  </TableHead>
                  <TableHead className="bg-[#33B9BA] text-white font-semibold">
                    Download Invoice
                  </TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                <TableRow>
                  <TableCell colSpan={6}>
                    <div className="flex min-h-96 justify-center items-center space-x-2">
                      <Loader2 className="h-6 w-6 animate-spin" />
                    </div>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TableLoader;
